/* vk-floaters.js v1.0 (2026-09-23) — 手机端底部悬浮件排位(老板 0923「10% 折扣 / 聊天 / 加购 互相挡住」)
   自下而上: 本站 .vk-sticky 加购条(仅产品页,出现时) → Klaviyo 折扣条(GET 10% OFF) → 聊天(Zoho, 右) 与 心愿单(Swym, 左) 同一层。
   只在 ≤749px 生效; 第三方件用 inline !important 覆盖 bottom; 元素出现/尺寸变化自动重排。零依赖。 */
(function () {
  'use strict';
  var GAP = 10;
  function mobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function vis(el) { if (!el) return false; var cs = getComputedStyle(el); if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false; var r = el.getBoundingClientRect(); return r.height > 0 && r.top < innerHeight; }
  function fixedRoot(el) { // Klaviyo 把 position:fixed 放在内层, 找到真正定位的那一层
    var n = el, i = 0;
    while (n && n !== document.body && i++ < 8) { if (getComputedStyle(n).position === 'fixed') return n; n = n.parentElement; }
    return null;
  }
  function klaviyoTeaser() {
    var c = document.querySelectorAll('[data-testid^="klaviyo-form"], [class*="klaviyo-form"]');
    for (var i = 0; i < c.length; i++) { var f = fixedRoot(c[i]) || c[i]; if (getComputedStyle(f).position !== 'fixed') { var inner = c[i].querySelector('[style*="fixed"]'); if (inner) f = inner; } if (getComputedStyle(f).position === 'fixed' && vis(f) && f.getBoundingClientRect().height < innerHeight * 0.4) return f; }
    return null;
  }
  function setBottom(el, px) { if (!el) return; if (el.dataset.vkFloatBottom == px) return; el.style.setProperty('bottom', px + 'px', 'important'); el.style.setProperty('top', 'auto', 'important'); el.dataset.vkFloatBottom = px; }
  function reset(el) { if (el && el.dataset.vkFloatBottom !== undefined) { el.style.removeProperty('bottom'); el.style.removeProperty('top'); delete el.dataset.vkFloatBottom; } }
  var els = {};
  function layout() {
    els.sticky = document.querySelector('.vk-sticky'); els.chat = document.getElementById('zsiq_float'); els.wish = document.getElementById('swym-anchor'); els.teaser = klaviyoTeaser();
    if (!mobile()) { reset(els.chat); reset(els.wish); reset(els.teaser); return; }
    var base = 0;
    if (els.sticky && vis(els.sticky) && els.sticky.getBoundingClientRect().bottom > innerHeight - 2) base = els.sticky.getBoundingClientRect().height + GAP; // 加购条贴底显示中
    if (els.teaser) { setBottom(els.teaser, base); base += els.teaser.getBoundingClientRect().height + GAP; }
    setBottom(els.chat, base + 6);
    setBottom(els.wish, base + 6);
  }
  var t; function schedule() { clearTimeout(t); t = setTimeout(layout, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('resize', schedule); window.addEventListener('scroll', schedule, { passive: true });
  if (window.MutationObserver) new MutationObserver(schedule).observe(document.body || document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  setInterval(layout, 1500);
  window.__vkFloaters = { layout: layout, v: '1.0' };
})();
